import Cookies from 'js-cookie';
import {
   CONSENT_COOKIE_EXPIRY_DAYS,
   CONSENT_COOKIE_NAME,
   CONSENT_ACCEPTED,
   CONSENT_REJECTED,
   CONSENT_PENDING,
   type ConsentValue,
   type IFixitConsentCookie,
} from './consent-types';
import { getCookieDomain } from '@ifixit/helpers';

export function getConsentFromCookie(): IFixitConsentCookie | null {
   const cookie = Cookies.get(CONSENT_COOKIE_NAME);
   if (!cookie) {
      return null;
   }

   try {
      const parsed = JSON.parse(cookie) as IFixitConsentCookie;
      if (
         parsed.isConsented === CONSENT_ACCEPTED ||
         parsed.isConsented === CONSENT_REJECTED ||
         parsed.isConsented === CONSENT_PENDING
      ) {
         return parsed;
      }
      return null;
   } catch {
      return null;
   }
}

export function setConsentCookie(consent: ConsentValue): void {
   const cookieValue: IFixitConsentCookie = {
      isConsented: consent,
   };
   Cookies.set(CONSENT_COOKIE_NAME, JSON.stringify(cookieValue), {
      expires: CONSENT_COOKIE_EXPIRY_DAYS,
      path: '/',
      sameSite: 'Lax',
      domain: getCookieDomain(window.location),
   });
}

export function hasUserConsentedFromCookie(piwikSiteId: string): boolean | null {
   const consentCookie = getConsentFromCookie();
   switch (consentCookie?.isConsented) {
      case CONSENT_ACCEPTED: {
         return true;
      }
      case CONSENT_REJECTED: {
         return false;
      }
      case CONSENT_PENDING: {
         return null;
      }
      default: {
         // TODO: Remove Piwik fallback after all Piwik cookies expire (~Mar 2027)
         return getPiwikConsentFromCookie(piwikSiteId);
      }
   }
}

// TODO: Remove after all Piwik cookies expire (~Mar 2027)
export function getPiwikConsentFromCookie(piwikSiteId: string): boolean | null {
   const cookie = Cookies.get(`ppms_privacy_${piwikSiteId}`);
   if (!cookie) {
      return null;
   }

   try {
      const cookieValue = JSON.parse(cookie) as {
         consents?: { [name: string]: { status: number } };
      };
      if (!cookieValue.consents) {
         return null;
      }
      return Object.values(cookieValue.consents).every(
         consent => consent.status === CONSENT_ACCEPTED
      );
   } catch {
      return null;
   }
}
